import React from "react";
import logo from "../../icons/logo.png";

export const Logo = () => {
  return (
    <div className="logo-section">
      <img src={logo} alt="Logo" className="app-logo" />
    </div>
  );
};

export default Logo;
